import ApiService from '@/services/api.service';
import getters from '@/store/global';

const state = {
    friendsOutgoing: {},
    count: '',
    next: '',
    errors: {}
};

getters['fetchOutgoing'] = function(state) { return state.friendsOutgoing }
getters['fetchOutgoingCount'] = function(state) { return state.count }
getters['fetchOutgoingNext'] = function(state) { return state.next }

const actions = {
    get(context, payload=false) {
        let url =
            payload ?
            'friends/requests/outgoing/?q=' + payload :
            'friends/requests/outgoing/';
        return ApiService
            .get(url)
            .then((response) => {
                context.commit('SET_ERROR', {});
                context.commit('SET_REQUESTS', response.data.results);
                context.commit('SET_COUNT', response.data.count);
                context.commit('SET_NEXT', response.data);
            })
            .catch(() => {
                throw new Error('Something goes wrong');
            });
    },
    getNext(context) {
        return ApiService
            .get(context.state.next)
            .then((response) => {
                context.commit('SET_ERROR', {});
                context.commit('ADD_REQUESTS', response.data.results);
                context.commit('SET_COUNT', response.data.count);
                context.commit('SET_NEXT', response.data);
            })
            .catch((response) => {
                context.commit('SET_ERROR', response.data);
                throw new Error('Something goes wrong');
            });
    },
    cancelAddFriends(context, payload) {
        return ApiService
            .delete('friends/' + payload + '/cancel_add/')
            .then((response) => {
                context.commit('SET_ERROR', {});
                context.commit('CANCEL_ADD', payload)
            })
            .catch(() => {
                throw new Error('Something goes wrong');
            });
    },
};

const mutations = {
    SET_REQUESTS(state, friendsOutgoing) {
        state.friendsOutgoing = friendsOutgoing;
        state.errors = {};
    },
    ADD_REQUESTS(state, friendsOutgoing) {
        state.friendsOutgoing = state.friendsOutgoing.concat(friendsOutgoing);
    },
    SET_NEXT(state, data) {
        let symbol = data.url.indexOf('?') == -1 ? '?' : '&';
        if (data.page < data.num_pages) {
            state.next =
            data.url +
            symbol +
            data.page_param +
            '=' +
            (data.page + 1);
        } else {
            state.next = '';
        }
        state.errors = {};
    },
    SET_COUNT(state, count) {
        state.count = count;
        state.errors = {};
    },
    SET_ERROR(state, errors) {
        state.errors = errors;
    },
    CANCEL_ADD(state, friendsOutgoing) {
        for (let i in state.friendsOutgoing) {
            if (state.friendsOutgoing[i].id == friendsOutgoing) {
                state.friendsOutgoing.splice(i, 1);
            }
        }
        state.count = --state.count;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
